export const IMPERSONATION_PREFIX = '/impersonate';

export function isImpersonationPathname(pathname: string): boolean {
  return pathname === IMPERSONATION_PREFIX || pathname.startsWith(`${IMPERSONATION_PREFIX}/`);
}

/** Strip `/impersonate` so step keys match PROSPECT_PORTAL_STEPS hrefs. */
export function logicalPortalPath(pathname: string): string {
  if (!isImpersonationPathname(pathname)) return pathname;
  const rest = pathname.slice(IMPERSONATION_PREFIX.length);
  return rest === '' ? '/' : rest;
}

export function portalHref(logicalHref: string, impersonating: boolean): string {
  const href = logicalHref.startsWith('/') ? logicalHref : `/${logicalHref}`;
  return impersonating ? `${IMPERSONATION_PREFIX}${href}` : href;
}
